import * as React from 'react';
import ContentHeader from '../contentHeader/ContentHeader';
import AccordionWrapper from '../accordionWrapper/AccordionWrapper';
import { MultiTradeInState, MultiTradeInUIProps } from '../../../types';
import { tradeInRoutes } from '../../../utils';
import { RouteProps } from 'react-router';

class MultiTradeInUI extends React.Component<MultiTradeInUIProps & RouteProps, MultiTradeInState> {
    private readonly MAX_TRADE_INS: number;

    constructor(props: MultiTradeInUIProps) {
        super(props);
        this.MAX_TRADE_INS = 3;
    }

    removeTradeIn = (index: number): void => {
        this.props.removeTradeIn(index);
    };

    render() {
        const {
            headerTitle,
            multiTradeInState,
            addTradeIn,
            isMultiTradeInsEnabled,
            location,
            tradeInSummary,
            goToNextStep,
            actionButtonText
        } = this.props;
        const { tradeIns } = multiTradeInState;
        const validRoutes = Object.values(tradeInRoutes) as string[];
        const isTradeinRoute = validRoutes.includes(location.pathname as string);

        if (!isTradeinRoute) return null;
        return (
            <div className="multi-tradein-page">
                <div className="multi-tradein-page-header">
                    <ContentHeader
                        title={headerTitle}
                        maxtradeIns={this.MAX_TRADE_INS}
                        multiTradeInState={multiTradeInState}
                        addTradeIn={addTradeIn}
                        isMultiTradeInsEnabled={isMultiTradeInsEnabled}
                        tradeInSummary={tradeInSummary}
                    />
                </div>

                <div className="multi-tradein-page-content">
                    {tradeIns.map((tradeIn, index) => (
                        <div key={index} className="multi-tradein-page-item">
                            <AccordionWrapper title={headerTitle} tradeIndex={index} tradeIn={tradeIn} {...this.props} />
                        </div>
                    ))}
                </div>

                {actionButtonText && (
                    <div className="multi-tradein-page-footer">
                        <button className="btn btn-primary" data-testid="multi-tradein-continue-btn" onClick={goToNextStep}>
                            {actionButtonText}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default MultiTradeInUI;
